import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const ContainerGrid = styled(Box)(({ theme }) => ({
  margin: '0 5%',
  [theme.breakpoints.up('xl')]: {
    margin: '0 auto',
    maxWidth: '1440px'
  },
  paddingBottom: '150px',
  [theme.breakpoints.up('md')]: {
    paddingBottom: '80px'
  }
}));

export const HubContainerGridStyled = styled(Box)(() => ({
  margin: '0 auto',
  paddingBottom:
    'calc(16px + env(safe-area-inset-bottom, 0px))' /* Avoid overlapping with safe area inset on iOS */,
  '@media (min-width: 1536px)': {
    margin: '0 auto',
    maxWidth: '1440px'
  }
}));

export const HubMainWrapperStyled = styled(Box)(({ theme }) => ({
  margin: 'auto',
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 13'
  }
}));

export const InfoContainerGrid = styled(Box)(({ theme }) => ({
  margin: '0 16px',
  [theme.breakpoints.up('md')]: {
    margin: '0 32px'
  }
}));
